export const SET_ERROR = "setError";
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
